import axios from 'axios';

const UpdateUserAPI = async (data, onSuccess, onError)=>{
    try{
        console.log("Printing payload for update user", data);
        const response = await axios.post("/user/update", data, {
            headers: {
                "Content-Type": "application/json"
            },
            withCredentials: true,
            baseURL: "https://salty-reaches-69347.herokuapp.com/"
        });
        onSuccess && onSuccess(response);
    }
    catch(err){
        onError && onError(err);
    }
};

export default UpdateUserAPI;